export const EHS_ORG_STATUS = {
    ENABLED: '1',
    DISABLED: '0'
}